import type { Task } from '~/types/models';

export type TaskScheduleDates = Pick<Task, 'dueDate' | 'startDate' | 'endDate'>;

export function normalizeTaskScheduleDates(startValue?: string, endValue?: string): TaskScheduleDates {
    const start = String(startValue || '').trim();
    const end = String(endValue || '').trim();

    if (start && end) {
        const sorted = [start, end].sort();
        return {
            dueDate: sorted[1],
            startDate: sorted[0],
            endDate: sorted[1],
        };
    }

    const deadline = start || end;
    return {
        dueDate: deadline || undefined,
        startDate: undefined,
        endDate: undefined,
    };
}

export function getTaskScheduleInputValues(task: Partial<Task>): { start: string; end: string } {
    return {
        start: String(task.startDate || task.dueDate || ''),
        end: task.startDate && task.endDate ? String(task.endDate) : '',
    };
}
